import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface PRSErrorResponse {
  httpErrorResponse: HttpErrorResponse,
  bodyRequest: string;
  urlWithParams: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  private _errorObservable: EventEmitter<PRSErrorResponse> = new EventEmitter();

  get errorObservable(): Observable<PRSErrorResponse> {
    return this._errorObservable.asObservable();
  }

  setError(httpErrorResponse: HttpErrorResponse) {
    this._errorObservable.emit({
      httpErrorResponse: httpErrorResponse,
    } as PRSErrorResponse);
  }

  setErrorAndRequest(httpErrorResponse: HttpErrorResponse, request: HttpRequest<unknown>) {
    let body: string = null
    try {
      body = JSON.stringify(request.body);
    } catch (error) {
    }
    this._errorObservable.emit({
      httpErrorResponse: httpErrorResponse,
      bodyRequest: body,
      urlWithParams: request.urlWithParams
    } as PRSErrorResponse);
  }
}
